import { render, staticRenderFns } from "./proposal-presentation.vue?vue&type=template&id=62032b33"
import script from "./proposal-presentation.vue?vue&type=script&lang=js"
export * from "./proposal-presentation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports